// extracted by mini-css-extract-plugin
module.exports = {"mainBlock":"styles_mainBlock__f6wXw","mainBlockTitle":"styles_mainBlockTitle__dwKo1","mainBlockText":"styles_mainBlockText__Gaoxw"};